import {Component, ViewChild} from '@angular/core';
import {TableComponent} from "../../ui/table/table.component";
import {Company} from "../../../models/company";
import {BaseComponent} from "../../base/base.component";

@Component({
    selector: 'app-dashboard-agent',
    templateUrl: './dashboard-agent.component.html',
    styleUrls: ['./dashboard-agent.component.scss']
})
export class DashboardAgentComponent extends BaseComponent {

    @ViewChild('companiesTable') companiesTable: TableComponent | undefined;
    @ViewChild('pendingCompaniesTable') pendingCompaniesTable: TableComponent | undefined;

    ngAfterViewInit() {
        this.companiesTable?.loadData('/companies',
            {
                agentId: this.getCurrentUser(),
            },
            (item: any) => {
                return new Company(item)
            })

        this.pendingCompaniesTable?.loadData('/companies',
            {
                agentId: this.getCurrentUser(),
                onlyPendingApprovation: true
            },
            (item: any) => {
                return new Company(item)
            })
    }
}
